export default __webpack_public_path__ + "static/media/pattern5.fd1c7676.png";